import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light', 
    useSystemColorMode: false, 
  },
  fonts: {
    heading: "'Diodrum Arabic Medium', sans-serif",
    body: "'Diodrum Arabic Medium', sans-serif",
    arabic: "'Diodrum Arabic Medium', sans-serif",
  },
   colors: {
    brand: {
      main: "#045846",
      secondary: "#ed2224",
    },
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.800",
        fontFamily: "body",
      },
    },
  },
});


export default theme;